export default {
  user: {},
  token: ''
}



// WEBPACK FOOTER //
// ./src/domain/auth/store/state.js